import { render, staticRenderFns } from "./SamplesConfirmationTable.vue?vue&type=template&id=7127bd78"
import script from "./SamplesConfirmationTable.vue?vue&type=script&lang=js"
export * from "./SamplesConfirmationTable.vue?vue&type=script&lang=js"
import style0 from "./SamplesConfirmationTable.vue?vue&type=style&index=0&id=7127bd78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports